import { ServiceRepo } from '@core/repositories'
const resource = "/contact";

export default {
  fetchSingle(id, config) {
    return ServiceRepo.get(`${resource}/${id}`, config);
  },
  delete(id, config) {
    return ServiceRepo.put(`${resource}/${id}/pseudonymize.json`, config)
  },
  fetchRecentTickets (payload, config) {
    return ServiceRepo.get(`${resource}s/recent_tickets`, payload, config);
  }
};
